import React from 'react';
import { SidebarLayout } from '@/components/Layout';
import { FinancialDashboard } from '../components/Financial';

const FinancialDashboardPage: React.FC = () => {
  return (
    <SidebarLayout>
      <FinancialDashboard />
    </SidebarLayout>
  );
};

export default FinancialDashboardPage;